import ForumCommentsList from "../../components/forums/comments/ForumCommentsList"

export const ForumComments = () => {

    return (
        <ForumCommentsList></ForumCommentsList>
    )
}